import { Component, ChangeDetectionStrategy, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, FormGroupDirective } from '@angular/forms';
import { AddressField } from '../service/form-field';
import { ShipmentFormStorage } from '../shipment-form-storage';

@Component({
    selector: 'address-form-field',
    template: require('./address-form-field.component.html'),
    styles: [require('./address-form-field.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressFormFieldComponent implements OnInit, OnChanges {

    @Input()
    public sequence: number;

    @Input()
    public groupName: string;

    @Input()
    public parentControlName: string;

    @Input()
    public isOrgNameRequired = true;

    @Input()
    public label: string;

    @Input()
    public placeholderLabel: string;

    @Input()
    public addressList: { key: number, value: string, address: AddressField }[];

    @Input()
    public customAddressList: { key: number, value: string, address: AddressField }[];

    @Input()
    public fieldKey: string;

    @Input()
    public showLoading: boolean;

    @Input()
    public hideParentField: boolean;

    @Input()
    public clearData = true;

    @Input()
    public countryList: { key: number, value: string, address: AddressField }[];

    public parentControl: FormControl;
    public formGroup: FormGroup;
    public expandSection = false;
    public autoSelected = false;
    public showError = false;

    @Input()
    public selectedAddress: AddressField = new AddressField();

    constructor(
        private formGroupDirective: FormGroupDirective,
        private storage: ShipmentFormStorage) {
    }

    public ngOnInit() {
        this.parentControl = this.formGroupDirective.control.get(this.parentControlName) as FormControl;
        this.formGroup = this.formGroupDirective.control.get(this.groupName) as FormGroup;
       // this.showError = this.parentControl.value ? true : false;
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.addressList && this.addressList && this.parentControl && this.parentControl.value !== 'Enter Custom Address' && !this.hideParentField) {
            if (this.addressList.length === 2 && !this.parentControl.value) {
                this.selectedAddress = this.addressList[0].address;
                this.setAddressForm();
                this.parentControl.setValue(this.addressList[0].value);
                this.autoSelected = true;
                //this.showError = true;
            }
            if ((this.addressList.length === 1) || (this.addressList.length > 2 && this.autoSelected)) {
                this.clearAddress();
            }
        }

        if (changes && changes.hideParentField && this.parentControl) {
            let formValue = this.hideParentField ? 'Others' : '';
            this.clearAddress(formValue);
        }
        if (changes.selectedAddress && this.hideParentField && this.parentControl) {
            let value = this.setParentValue();
            if (value !== 'Others') {
                this.setAddressForm();
            }
            //this.showError = true;
        }
    }

    public getFormGroupName(fieldName: string) {
        return this.fieldKey + fieldName;
    }

    public getFormControl(name: string) {
        let key = this.getFormGroupName(name);
        return this.formGroupDirective.control.get(this.groupName).get(key) as FormControl;
    }

    public showChildFields() {
        if (this.parentControl.value && this.formGroup.invalid) { return true; }
        if (this.parentControl.value === 'Enter Custom Address') { return true; }
        return this.hideParentField;
    }

    public onAddressSelected($event: any) {
        if (!$event) { return; }
        this.selectedAddress = $event.address;
        this.setAddressForm();
        this.autoSelected = false;
        //this.showError = true;
    }

    private clearAddress(parentValue = '') {
        if (!this.clearData) { return; }
        this.selectedAddress = {};
        this.parentControl.setValue(parentValue);
        this.setAddressForm();
        //this.showError = parentValue.length > 0 ? true : false;
    }

    private setAddressForm() {
        if (!this.formGroup) { return; }
        if (!this.selectedAddress.companyName && !this.clearData) { return; }
        let orgName = this.selectedAddress.companyName;
        let addressLine1 = this.selectedAddress.addressLineOne;
        let addressLine2 = this.selectedAddress.addressLineTwo;
        if (this.selectedAddress.departmentName && this.selectedAddress.departmentName.length > 1) {
            if ((orgName + ', ' + this.selectedAddress.departmentName).length < 30) {
                orgName = orgName + ', ' + this.selectedAddress.departmentName;
            } else {
                addressLine1 = this.selectedAddress.departmentName;
                addressLine2 = !addressLine2 ? this.selectedAddress.addressLineOne : this.selectedAddress.addressLineOne + ',' + addressLine2;
            }

        }
        this.formGroup.get(this.fieldKey + 'OrgName').setValue(orgName);
        this.formGroup.get(this.fieldKey + 'AddressLine1').setValue(addressLine1);
        this.formGroup.get(this.fieldKey + 'AddressLine2').setValue(addressLine2);
        this.formGroup.get(this.fieldKey + 'City').setValue(this.selectedAddress.city);
        this.formGroup.get(this.fieldKey + 'State').setValue(this.selectedAddress.state);
        this.formGroup.get(this.fieldKey + 'PostalCode').setValue(this.selectedAddress.zipCode);
        this.formGroup.get(this.fieldKey + 'Country').setValue(this.selectedAddress.countryName);
        this.formGroup.get(this.fieldKey + 'OrgPhone').setValue(this.selectedAddress.phone);
    }

    private setParentValue() {
        let value = this.storage.getAddressValue(this.selectedAddress);
        value = value ? value : 'Others';
        this.parentControl.setValue(value);
        return value;
    }
}